import { render, staticRenderFns } from "./BaBringBidWantedModal.vue?vue&type=template&id=3c8e7ff2&scoped=true&"
import script from "./BaBringBidWantedModal.vue?vue&type=script&lang=js&"
export * from "./BaBringBidWantedModal.vue?vue&type=script&lang=js&"
import style0 from "./BaBringBidWantedModal.vue?vue&type=style&index=0&id=3c8e7ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e7ff2",
  null
  
)

export default component.exports